"use client";

import React, { useEffect, useRef } from "react";

const BannerLabel = () => {
  const desktopMarqueeRef = useRef<HTMLDivElement>(null);
  const mobileMarqueeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const setupMarquee = (marqueeRef: React.RefObject<HTMLDivElement>) => {
      const marquee = marqueeRef.current;
      if (!marquee) return;

      let translateX = 0;
      const speed = 0.02;
      let animationFrameId: number;

      const animate = () => {
        translateX -= speed;
        if (translateX <= -33.33) {
          translateX = 0;
        }
        marquee.style.transform = `translate3d(${translateX}%, 0, 0)`;
        animationFrameId = requestAnimationFrame(animate);
      };

      animationFrameId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrameId);
    };

    const cleanupDesktop = setupMarquee(desktopMarqueeRef);
    const cleanupMobile = setupMarquee(mobileMarqueeRef);

    return () => {
      cleanupDesktop?.();
      cleanupMobile?.();
    };
  }, []);

  const content = [
    { count: "DUBAI" },
    { count: "NEW YORK" },
    { count: "BANGALORE" },
    { count: "CHENNAI" },
    { count: "AHMEDABAD" },
    { count: "DELHI" },
    { count: "KOCHI" },
    { count: "HYDERABAD" },
    { count: "MUMBAI" },
    { count: "KOLKATA" },
    { count: "PUNE" },
  ];

  return (
    <>
      {/* Desktop Version */}
      <div className="md:block hidden w-full bg-gradient-to-r from-[#FFF3D6] via-[#A7D3FF] to-[#FFF3D6] overflow-hidden py-2 relative">
        <div className="overflow-hidden w-full relative z-10">
          <div
            ref={desktopMarqueeRef}
            className="flex gap-16"
            style={{
              width: "max-content",
              textRendering: "optimizeLegibility",
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
            }}
          >
            {[...content, ...content, ...content].map((item, index) => (
              <div
                key={`desktop-${index}`}
                className="flex items-center gap-2 text-[18px] md:text-[20px] font-semibold text-[#01060B] flex-shrink-0 whitespace-nowrap"
              >
                <span className="text-[20px] md:text-[22px] font-bold text-[#01060B]">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="md:hidden block w-full bg-gradient-to-r from-[#FFF3D6] via-[#A7D3FF] to-[#FFF3D6] overflow-hidden py-3 relative">
        <div className="overflow-hidden w-full relative z-10">
          <div
            ref={mobileMarqueeRef}
            className="flex gap-8"
            style={{
              width: "max-content",
              textRendering: "optimizeLegibility",
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
            }}
          >
            {[...content, ...content, ...content].map((item, index) => (
              <div
                key={`mobile-${index}`}
                className="flex items-center gap-2 text-[14px] font-semibold text-[#01060B] flex-shrink-0 whitespace-nowrap"
              >
                <span className="text-[16px] font-bold text-[#01060B]">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerLabel;
